import { useMapEvents } from 'react-leaflet';

interface LocationSelectorProps {
  isSelecting: boolean;
  onLocationSelect: (e: any) => void;
  onMapClick?: () => void;
}

/**
 * Component to handle map clicks for location selection
 * Used when selecting a temporary location on the map
 */
export const LocationSelector: React.FC<LocationSelectorProps> = ({
  isSelecting,
  onLocationSelect,
  onMapClick,
}) => {
  useMapEvents({
    click: (e) => {
      if (isSelecting) {
        onLocationSelect(e);
      } else if (onMapClick) {
        onMapClick();
      }
    },
  });

  return null;
};
